import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  Card,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Switch,
  TableContainer,
  TextField,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginBottom: "10px",
    marginRight: "15px",
  },
  animatedButton: {
    background: "linear-gradient(45deg, #ff416c 30%, #ff4b2b 90%)",
    color: "#fff",
    padding: "10px 30px",
    fontSize: "16px",
    fontWeight: "bold",
    textTransform: "none",
    borderRadius: "5px",
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
    },
  },
});
const rows = [
  {
    id: 1,
    name: "Vendor 1",
    purchasecate: "Transactional SMS",
    communicationtype: "SMS",
    count: "70",
    inward_type:"Purhased",
    validtype: "Limited",
    validfrom: "25/8/2025",
    validto: "25/8/2025",
    totalcost: "855",
    invoice: "856329",
  },
  {
    id: 2,
    name: "Vendor 1",
    purchasecate: "Transactional Whatsapp",
    communicationtype: "Whatsapp",
    count: "85",
    inward_type:"Expired Refersal",
    validtype: "Unlimited",
    validfrom: "25/8/2025",
    validto: "25/8/2025",
    totalcost: "521",
    invoice: "856325",
  },
];

const handleView = (row) => {
  alert(`Viewing: ${row.name}`);
};

const handleEdit = (row) => {
  alert(`Editing: ${row.name}`);
};

const columns = [
  {
    field: "id",
    headerName: "S.No",
    width: 70,
    sortable: false,
  },
  { field: "name", headerName: "Vendor Name/Client Name", width: 150 },
  { field: "purchasecate", headerName: "Purchase Category", width: 150 },
  { field: "communicationtype", headerName: "Communication Type", width: 200 },
  { field: "inward_type", headerName: "Inward Type", width: 200 },
  { field: "count", headerName: "Count", width: 120 },
  { field: "validtype", headerName: "Validity Type", width: 150 },
  { field: "validfrom", headerName: "Valid From", width: 150 },
  { field: "validto", headerName: "Valid To", width: 200 },
  { field: "totalcost", headerName: "Total Purchase Cost", width: 130 },
  { field: "invoice", headerName: "Invoice Number", width: 200 },
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <>
        <Tooltip title="Edit">
          <IconButton color="primary" onClick={() => handleEdit(params.row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="View">
          <IconButton color="primary" onClick={() => handleView(params.row)}>
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
      </>
    ),
  },
];

const VendorList = () => {
  const classes = useStyles();
  return (
    <>
      <Card elevation={3} sx={{ marginBottom: "15px" }}>
        <Grid container spacing={2} sx={{ p: 2 }}>
          <Grid item xs={12} md={3}>
            <TextField
              label="Name"
              name="name"
              fullWidth
            //   value={filters.name}
            //   onChange={(e) => setFilters({ ...filters, name: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Mobile Number"
              name="mobilenumber"
              fullWidth
            //   value={filters.mobilenumber}
            //   onChange={(e) =>
            //     setFilters({ ...filters, mobilenumber: e.target.value })
            //   }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Email"
              name="mobilenumber"
              fullWidth
            //   value={filters.mobilenumber}
            //   onChange={(e) =>
            //     setFilters({ ...filters, mobilenumber: e.target.value })
            //   }
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Sourced For</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                // value={age}
                label="Sourced For"
              // onChange={handleChange}
              >
                <MenuItem value="sms">Transactional SMS</MenuItem>
                <MenuItem value="email">Transactional Whatsapp</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Communication type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                // value={age}
                label="City"
              // onChange={handleChange}
              >
                <MenuItem value="chennai">SMS</MenuItem>
                <MenuItem value="madurai">Whatsapp</MenuItem>
                <MenuItem value="salem">Email</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Inward type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                // value={age}
                label="City"
              // onChange={handleChange}
              >
                <MenuItem value="chennai">Purchased</MenuItem>
                <MenuItem value="madurai">Expired Refersal</MenuItem>
                <MenuItem value="salem">Adjustment Counts</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Validity Type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                // value={age}
                label="State"
              // onChange={handleChange}
              >
                <MenuItem value="tamilnadu">Limited</MenuItem>
                <MenuItem value="kerala">Unlimited</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Box className={classes.buttonContainer}>
          <Button
            // className={classes.animatedButton}
            variant="outlined"
          // onClick={handleReset}
          >
            Reset
          </Button>
          <Button
            className={classes.animatedButton}
            variant="contained"
          // onClick={handleSearch}
          >
            Search
          </Button>
        </Box>
      </Card>
      <Card elevation={3}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          disableSelectionOnClick
        />
      </Card>
    </>
  );
};

export default VendorList;
